import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import { getPendingSendCount, getPendingSendPersons } from '@/services/salarylb';
export default {
  name: 'SalarySendModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedRange: 1,
      // 默认选择全部人员
      selectedPersons: [],
      // 选择的人员
      searchKeyword: '',
      // 搜索关键词
      availablePersons: [],
      // 可供选择的人员列表
      pendingSendCount: 0 // 待发送记录数
    };
  },
  computed: {
    // 计算总记录数
    totalRecords: function totalRecords() {
      return this.record.recordCount || 0;
    },
    // 计算待发送记录数
    pendingSendRecords: function pendingSendRecords() {
      return this.pendingSendCount || 0;
    }
  },
  watch: {
    visible: function visible(newVal) {
      if (newVal) {
        this.initData();
      }
    }
  },
  methods: {
    initData: function initData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // 初始化数据
              _this.selectedRange = 1;
              _this.selectedPersons = [];
              _this.searchKeyword = '';
              // 获取待发送记录数
              _context.n = 1;
              return _this.fetchPendingSendCount();
            case 1:
              _context.n = 2;
              return _this.loadAvailablePersons();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    fetchPendingSendCount: function fetchPendingSendCount() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(_this2.record && _this2.record.id)) {
                _context2.n = 5;
                break;
              }
              _context2.p = 1;
              _context2.n = 2;
              return getPendingSendCount(_this2.record.id);
            case 2:
              response = _context2.v;
              if (response.data.code === 200) {
                _this2.pendingSendCount = response.data.data || 0;
              } else {
                _this2.pendingSendCount = 0;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              _this2.pendingSendCount = 0;
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _this2.pendingSendCount = 0;
            case 6:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }))();
    },
    loadAvailablePersons: function loadAvailablePersons() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var response, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(_this3.record && _this3.record.id)) {
                _context3.n = 5;
                break;
              }
              _context3.p = 1;
              _context3.n = 2;
              return getPendingSendPersons(_this3.record.id);
            case 2:
              response = _context3.v;
              if (response.data.code === 200) {
                _this3.availablePersons = response.data.data.map(function (person) {
                  return {
                    id: person.id,
                    // 使用真实的ID
                    name: person.name,
                    jobNumber: person.idcard // 使用身份证号作为工号显示
                  };
                }) || [];
              } else {
                _this3.availablePersons = [];
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              _this3.availablePersons = [];
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _this3.availablePersons = [];
            case 6:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 3]]);
      }))();
    },
    onSearch: function onSearch(value) {
      // 根据关键词过滤人员列表
      if (!value.trim()) {
        this.loadAvailablePersons();
        return;
      }
      this.availablePersons = this.availablePersons.filter(function (person) {
        return person.name.includes(value) || person.jobNumber.includes(value);
      });
    },
    handleOk: function handleOk() {
      // 验证用户选择
      if (this.selectedRange === 3 && this.selectedPersons.length === 0) {
        this.$message.warning('请选择要发送的教职工');
        return;
      }

      // 构造参数对象
      var params = {
        importRecordId: this.record.id,
        sendRange: this.selectedRange,
        selectedPersonIds: this.selectedRange === 3 ? this.selectedPersons : undefined
      };

      // 通知父组件执行发送操作
      this.$emit('confirm-send', params);
      this.handleCancel();
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};